define("shared/components/shared/credentials/tiktok-refresh-confirm", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@handleClose}} @focusTrap={{true}} @primaryClass="o--modalBg u--p__0" as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header class="u--p__b__xs">
        <p>
          <b>{{t "tiktok.confirm_refresh.title"}}</b>
        </p>
      </modal.card-header>
  
      <modal.card-body>
        <div class="u--m__b__md">
          {{html-safe (t "tiktok.confirm_refresh.body")}}
        </div>
  
        <hr class="u--m__t__lg" />
  
        <label>
          <Input
            @checked={{this.confirmTiktokCheckbox}}
            @type="checkbox"
            data-test-id="tiktok-refresh-confirm-checkbox"
          />
          <span class="u--text--base">
            {{t "tiktok.confirm_refresh.agree_terms"}}
          </span>
        </label>
      </modal.card-body>
  
      <modal.card-footer>
        <div class="u--row">
          <div class="u--col__12">
            <Shared::Ui::Button
              @class="o--btn u--float--left"
              @onClick={{@handleClose}}
              @text={{t "shared_words.cancel"}}
              @variant="outline"
            />
  
            <Shared::Ui::Button
              @class="u--float--right"
              @isDisabled={{not this.confirmTiktokCheckbox}}
              @onClick={{@refreshUnverifiedTiktok}}
              @text={{t "shared_words.continue"}}
              @variant="primary"
              data-test-id="tiktok-refresh-confirm-confirm-button"
            />
          </div>
        </div>
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "CWkH/kv8",
    "block": "[[[8,[39,0],null,[[\"@close\",\"@focusTrap\",\"@primaryClass\"],[[30,1],true,\"o--modalBg u--p__0\"]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],[[24,0,\"u--p__b__xs\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[12],[1,\"\\n        \"],[10,\"b\"],[12],[1,[28,[35,1],[\"tiktok.confirm_refresh.title\"],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,2,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"u--m__b__md\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[[28,[37,1],[\"tiktok.confirm_refresh.body\"],null]],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,\"hr\"],[14,0,\"u--m__t__lg\"],[12],[13],[1,\"\\n\\n      \"],[10,\"label\"],[12],[1,\"\\n        \"],[8,[39,3],[[24,\"data-test-id\",\"tiktok-refresh-confirm-checkbox\"]],[[\"@checked\",\"@type\"],[[30,0,[\"confirmTiktokCheckbox\"]],\"checkbox\"]],null],[1,\"\\n        \"],[10,1],[14,0,\"u--text--base\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"tiktok.confirm_refresh.agree_terms\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"u--col__12\"],[12],[1,\"\\n          \"],[8,[39,4],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"o--btn u--float--left\",[30,1],[28,[37,1],[\"shared_words.cancel\"],null],\"outline\"]],null],[1,\"\\n\\n          \"],[8,[39,4],[[24,\"data-test-id\",\"tiktok-refresh-confirm-confirm-button\"]],[[\"@class\",\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[\"u--float--right\",[28,[37,5],[[30,0,[\"confirmTiktokCheckbox\"]]],null],[30,3],[28,[37,1],[\"shared_words.continue\"],null],\"primary\"]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@handleClose\",\"modal\",\"@refreshUnverifiedTiktok\"],false,[\"shared/modal\",\"t\",\"html-safe\",\"input\",\"shared/ui/button\",\"not\"]]",
    "moduleName": "shared/components/shared/credentials/tiktok-refresh-confirm.hbs",
    "isStrictMode": false
  });
  class TiktokRefreshComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "confirmTiktokCheckbox", false);
    }
  }
  _exports.default = TiktokRefreshComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TiktokRefreshComponent);
});